import { gettext as _ } from "../utils/i18n";

function addLink() {
    //Get the selected text and append the extra info
    var selection = window.getSelection(),
        pagelink = "<br><br>" + _("Source") + ": " + document.location.href,
        copytext = selection + pagelink,
        newdiv = document.createElement("div");

    //hide the newly created container
    newdiv.style.position = "absolute";
    newdiv.style.left = "-99999px";

    //insert the container, fill it with the extended text, and define the new selection
    document.body.appendChild(newdiv);
    newdiv.innerHTML = copytext;
    selection.selectAllChildren(newdiv);

    window.setTimeout(function () {
        document.body.removeChild(newdiv);
    }, 100);
}

export function init_add_link_to_clipboard() {
    // Register copy event, but not for staff
    if (!window.USER_IS_STAFF) {
        document.addEventListener("copy", addLink);
    }
}
